import React from 'react'
import { datalayerHandler } from '../../../../utils/datalayer'
import { Image } from '../../../../utils/image'
import { Link } from '../../../../utils/link'
import { highlightBlockClasses } from '../../../../utils/style'
import { convertReactNodeToString, getClassName, htmlDecode, unEntity } from '../../../../utils/utils'
import { HighlightBlock } from '../blocksState'
import { useInView } from '../../../hooks/useInView'

export type HighlightBlockStyle = Partial<{
  blockClassName: string
  inviewClassName: string
  innerClassName: string
  headerClassName: string
  labelClassName: string
  titleClassName: string
  contentClassName: string
  textClassName: string
  footerClassName: string
  visualClassName: string
  imageClassName: string
  pictureClassName: string
  clickableClassName: string
  clickableLabelClassName: string
}>

export const HighlightBlockLayout = (props: HighlightBlock) => {
  const { image, inview, index, intro, primaryAction, title, label } = props

  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("HighlightBlockLayout inView:", inview),
    !inview?.triggerOnce
  )

  const isClickable = Boolean(primaryAction?.title && primaryAction?.url)

  return (
    <section
      key={`block-${index}`}
      id={`io-${index}`}
      ref={ref}
      className={[
          getClassName(highlightBlockClasses, 'blockClassName', ''),
          isClickable ? 'block--clickable' : '',
          inView ? getClassName(highlightBlockClasses, 'inviewClassName', 'inview') : '',
        ].filter(Boolean).join(' ')}
    >
      <div className={getClassName(highlightBlockClasses, 'innerClassName', '')}>
        <div className={getClassName(highlightBlockClasses, 'contentClassName', '')}>
          {title && (
            <header className={getClassName(highlightBlockClasses, 'headerClassName', '')}>
              <h2 className={getClassName(highlightBlockClasses, 'titleClassName', '')}>
                <span id={`${index}`} aria-hidden="true" className="block__anchor" />
                {typeof title === 'string' ? htmlDecode(title) : title}
              </h2>
            </header>
          )}
          {label && <span className={getClassName(highlightBlockClasses, 'labelClassName', '')}>{htmlDecode(label)}</span>}

          {intro && <p className={getClassName(highlightBlockClasses, 'textClassName', '')}>{unEntity(intro)}</p>}

          {(primaryAction?.title) && (
            <footer className={getClassName(highlightBlockClasses, 'footerClassName', '')}>
              <Link
                title={primaryAction.title}
                url={primaryAction.url}
                className={getClassName(highlightBlockClasses, 'clickableClassName', '')}
                additionalOnClick={() =>
                  datalayerHandler('cta', undefined, undefined, {
                    kind: 'link',
                    title: convertReactNodeToString(title),
                    link: primaryAction.url,
                    label: primaryAction.title,
                  })
                }
              >
                <span className={getClassName(highlightBlockClasses, 'clickableLabelClassName', '')}>
                  {htmlDecode(primaryAction.title)}
                </span>
              </Link>
            </footer>
          )}
        </div>

        <div className={getClassName(highlightBlockClasses, 'visualClassName', '')}>
          <Image
            {...image}
            classNames={{
              image: getClassName(highlightBlockClasses, 'imageClassName', ''),
              picture: getClassName(highlightBlockClasses, 'pictureClassName', ''),
            }}
          />
        </div>
      </div>
    </section>
  )
}
